import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  upload,
  uploadItemValidate,
  getFileBlob,
  getExport,
} from "./specialdiscAPI";

const initialState = {
  data: [],
  dataId: null,
  dataHistory: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "specialDisc/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchSpecialDisc = createAsyncThunk(
  "specialDisc/fetchSpecialDisc",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("specialDisc/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "specialDisc/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "specialDisc/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "specialDisc/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "specialDisc/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "specialDisc/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "specialDisc/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const fetchTemplate = createAsyncThunk(
  "ultis/fetchTemplate",
  async (payload) => {
    const response = await getFileBlob(payload);
    return response;
  }
);

export const fetchExport = createAsyncThunk(
  "specialDisc/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const specialDiscSlice = createSlice({
  name: "specialDisc",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchSpecialDisc.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchSpecialDisc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = specialDiscSlice.actions;

export const selectData = (state) => state.specialDisc.data;
export const selectSpecialDisc = (state) => state.specialDisc.data;
export const selectId = (state) => state.specialDisc.dataId;
export const selectIdHistory = (state) => state.specialDisc.dataHistory;
export const selectLoading = (state) => state.specialDisc.loading;
export const selectLoadingTemplate = (state) => state.specialDisc.loading;
export const selectError = (state) => state.specialDisc.error;
export const selectPageNo = (state) => state.specialDisc.pageNo;
export const selectPageSize = (state) => state.specialDisc.pageSize;
export const selectTotalRecord = (state) => state.specialDisc.totalRecord;
export const selectSelected = (state) => state.specialDisc.selected;
export const selectResult = (state) => state.specialDisc.result;

export default specialDiscSlice.reducer;
